<template>
  <div id="app" :class="{'no-authorize':!isAuthorize}">
    <!--<button style="display: none;" @click="clickBtn" id="btnRef">刷新按钮</button>-->
    <keep-alive :include="cacheList">
      <router-view v-if="isAuthorize"/>
    </keep-alive>
  </div>
</template>

<script>
import { mainService } from 'services/liveManage.main.js';
import { wxShare } from 'utils/wetChat.js';
export default {
  name: 'App',
  data () {
    return {
      isAuthorize: true // 是否授权
    };
  },
  computed: {
    cacheList () {
      return this.$store.state.cacheList;
    }
  },
  mounted () {
    // window.addEventListener('beforeunload', e => this.beforeunloadFn(e));
  },
  methods: {
    // 需要显示刷新询问弹框，需要调用此方法
    // clickBtn () {
    //   console.log('hahaha>>>>>>');
    // },
    // beforeunloadFn (e) {
    //   e = e || window.event;
    //   let date = parseInt(new Date().getTime() / 1000);
    //   let oldDate = window.sessionStorage.getItem('sessionTime');
    //   if (date - oldDate < 5) {
    //     // this.$notify.error({
    //     //   title: '错误',
    //     //   message: '对不起，您的刷新操作过于频繁！'
    //     // });
    //     this.$message.info('对不起，您的刷新操作过于频繁！');
    //     this.clickBtn();
    //     e.returnValue = false;
    //     e.cancelBubble = true;
    //     return false;
    //   } else {
    //     window.sessionStorage.setItem('sessionTime', date);
    //     return true;
    //   }
    // }
  },
  destroyed () {
    // window.removeEventListener('beforeunload', e => this.beforeunloadFn(e));
    // window.sessionStorage.removeItem('sessionTime');
  },
  created () {
    // window.sessionStorage.setItem('sessionTime', parseInt(new Date().getTime() / 1000));
    mainService.checkAuthorize().then(res => {
      // 未授权的情况下，要进行处理
      this.isAuthorize = res.data.code === 0;
    });
    let isPhone = window.innerWidth < 768;
    if (isPhone) {
      // 获取微信签名信息
      let params = {
        url: window.location.protocol + '//cloudlive.zonekey.com.cn/cloudlive/index.html'
      };
      mainService.wxShare(params).then(res => {
        if (res.data.data) {
          let result = {
            debug: false,
            appId: 'wxf2c370962dca3963',
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']
          };
          this.$store.commit('setWxConfig', result);
        }
        wxShare();
      });
    }
  }
};
</script>

<style lang="scss">
.no-authorize {
  height: 100vh;
  width: 100vw;
  background: url(assets/images/no-authorize-pc.png) no-repeat center;
  @media only screen and (max-width: 992px) and (min-width: 768px) {
    background: url(assets/images/no-authorize-pad.png) no-repeat center;
  }
  @media only screen and (max-width: 767px) {
    background: url(assets/images/no-authorize-app.png) no-repeat center;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue